var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.584.753H2.393a1.64 1.64 0 0 0-1.64 1.62v19.253a1.64 1.64 0 0 0 1.64 1.621h19.208c.9 0 1.631-.722 1.646-1.62V2.375A1.645 1.645 0 0 0 21.602.753h-.022zM7.425 19.922h-3.34V9.188h3.34zM5.755 7.72A1.934 1.934 0 1 1 7.69 5.785v.003A1.933 1.933 0 0 1 5.757 7.72zm14.162 12.202h-3.33v-5.22c0-1.245-.026-2.846-1.736-2.846-1.737 0-2.002 1.354-2.002 2.755v5.311h-3.33V9.19h3.199v1.463h.043a3.52 3.52 0 0 1 3.165-1.734h-.007c3.375 0 4 2.222 4 5.113v5.891h-.002z"
  })));
};
export default SvgLinkedin;